import { ReduxAction } from 'app/redux/types';

// ---

export const ADD_IN_BLOCKED_STAKES_QUEUE = 'BET_SLIP:ADD_IN_BLOCKED_STAKES_QUEUE';

export type AddInBlockedStakesQueue = ReduxAction<
  typeof ADD_IN_BLOCKED_STAKES_QUEUE, {
  dialogId: string;
}>;

export const addInBlockedStakesQueue = (dialogId: string): AddInBlockedStakesQueue => ({
  type: ADD_IN_BLOCKED_STAKES_QUEUE,
  payload: { dialogId },
});

// ---

export const DELETE_FROM_BLOCKED_STAKES_QUEUE = 'BET_SLIP:DELETE_FROM_BLOCKED_STAKES_QUEUE';

export type DeleteFromBlockedStakesQueue = ReduxAction<
  typeof DELETE_FROM_BLOCKED_STAKES_QUEUE, {
  dialogId: string;
}>;

export const deleteFromBlockedStakesQueue = (dialogId: string): DeleteFromBlockedStakesQueue => ({
  type: DELETE_FROM_BLOCKED_STAKES_QUEUE,
  payload: { dialogId },
});
